import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Témoignages Clients - CasaReNovaPlus Neuenegg",
  "description": "Avis et témoignages de clients satisfaits de CasaReNovaPlus à Neuenegg. Plus de 200 projets de rénovation réalisés en Suisse romande.",
  "url": `${import.meta.env.VITE_SITE_URL}/temoignages`,
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "author": {
    "@type": "Organization",
    "name": "CasaReNovaPlus",
    "url": `${import.meta.env.VITE_SITE_URL}`
  }
};

export default function Temoignages() {
  const testimonials = [
    {
      id: 1,
      name: "Sophie Mercier",
      location: "Carouge, Genève",
      service: "Installation Pompe à Chaleur",
      rating: 5,
      date: "Janvier 2025",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20female%20homeowner%20in%20her%20forties%20standing%20in%20modern%20swiss%20home%20interior%20with%20natural%20lighting%20and%20contemporary%20design&width=400&height=400&seq=test1&orientation=squarish",
      text: "Installation d'une pompe à chaleur air-eau dans notre villa à Carouge. Service impeccable de A à Z ! L'équipe de HB SERVICES a été professionnelle, ponctuelle et très soigneuse. Notre facture de chauffage a diminué de 65% dès le premier hiver. Je recommande vivement pour toute installation de pompe à chaleur à Genève.",
      project: "Remplacement chaudière mazout par PAC air-eau 12kW avec plancher chauffant"
    },
    {
      id: 2,
      name: "Marc Dubois",
      location: "Meyrin, Genève",
      service: "Rénovation Électrique Complète",
      rating: 5,
      date: "Décembre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20male%20business%20owner%20in%20his%20fifties%20in%20modern%20office%20environment%20with%20natural%20lighting%20and%20contemporary%20swiss%20interior&width=400&height=400&seq=test2&orientation=squarish",
      text: "Rénovation électrique complète de notre appartement à Meyrin. Mise aux normes NIBT, nouveau tableau électrique avec disjoncteurs différentiels, installation domotique KNX et éclairage LED. Travail soigné, respect des délais et excellent conseil. L'électricien était très compétent et a su répondre à toutes nos questions techniques.",
      project: "Rénovation électrique 120m² avec domotique KNX et éclairage intelligent"
    },
    {
      id: 3,
      name: "Isabelle Laurent",
      location: "Genève Centre",
      service: "Rénovation Salle de Bain",
      rating: 5,
      date: "Décembre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20female%20professional%20in%20her%20thirties%20in%20elegant%20modern%20swiss%20apartment%20with%20natural%20lighting%20and%20sophisticated%20interior%20design&width=400&height=400&seq=test3&orientation=squarish",
      text: "Rénovation complète de notre salle de bain en plein centre de Genève. Douche italienne, robinetterie Hansgrohe, WC suspendu Geberit, carrelage grand format. Le plombier et son équipe ont fait un travail remarquable. Finitions parfaites, chantier propre et respect du budget. Notre salle de bain est magnifique !",
      project: "Rénovation salle de bain 8m² avec douche italienne et équipements haut de gamme"
    },
    {
      id: 4,
      name: "Pierre Fontaine",
      location: "Vernier, Genève",
      service: "Installation VMC Double Flux",
      rating: 5,
      date: "Novembre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20male%20engineer%20in%20his%20forties%20in%20modern%20swiss%20home%20office%20with%20natural%20lighting%20and%20technical%20equipment%20in%20background&width=400&height=400&seq=test4&orientation=squarish",
      text: "Installation d'une ventilation mécanique contrôlée double flux dans notre maison à Vernier. Excellent travail ! La qualité de l'air intérieur s'est nettement améliorée et nous avons constaté une réduction de 30% sur notre facture de chauffage. L'équipe HB SERVICES maîtrise parfaitement la ventilation et l'aéraulique.",
      project: "VMC double flux avec récupération de chaleur pour maison 180m²"
    },
    {
      id: 5,
      name: "Catherine Morel",
      location: "Lancy, Genève",
      service: "Dépannage Urgence Plomberie",
      rating: 5,
      date: "Novembre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20female%20homeowner%20in%20her%20fifties%20in%20comfortable%20modern%20swiss%20living%20room%20with%20natural%20lighting%20and%20elegant%20contemporary%20decor&width=400&height=400&seq=test5&orientation=squarish",
      text: "Fuite d'eau importante un dimanche soir à Lancy. J'ai contacté HB SERVICES en urgence et un plombier est intervenu en moins d'une heure ! Détection de fuite rapide avec caméra thermique, réparation immédiate et tarif honnête. Service d'urgence 24h/7j vraiment efficace. Merci pour votre réactivité !",
      project: "Dépannage urgence : détection et réparation fuite d'eau sous dalle"
    },
    {
      id: 6,
      name: "Jean-Luc Perrin",
      location: "Thônex, Genève",
      service: "Installation Domotique KNX",
      rating: 5,
      date: "Octobre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20male%20technology%20enthusiast%20in%20his%20forties%20in%20modern%20smart%20home%20environment%20with%20natural%20lighting%20and%20contemporary%20design&width=400&height=400&seq=test6&orientation=squarish",
      text: "Installation complète d'un système domotique KNX dans notre villa à Thônex. Éclairage intelligent, chauffage automatisé, volets roulants, alarme et vidéosurveillance. Tout est contrôlable depuis notre smartphone. L'équipe est très compétente en domotique et a su nous conseiller sur les meilleures solutions. Maison connectée parfaite !",
      project: "Domotique KNX complète avec 45 points de commande et supervision iPad"
    },
    {
      id: 7,
      name: "Anne-Marie Blanc",
      location: "Onex, Genève",
      service: "Entretien Chaudière Gaz",
      rating: 5,
      date: "Octobre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20senior%20female%20homeowner%20in%20her%20sixties%20in%20cozy%20modern%20swiss%20home%20interior%20with%20natural%20lighting%20and%20warm%20atmosphere&width=400&height=400&seq=test7&orientation=squarish",
      text: "Entretien annuel de notre chaudière gaz à condensation à Onex. Service impeccable, ponctuel et professionnel. Le technicien a effectué un contrôle complet : combustion, ramonage, nettoyage, réglages. Il a pris le temps de m'expliquer le fonctionnement et m'a donné de précieux conseils d'entretien. Tarif très correct pour la qualité du service.",
      project: "Entretien chaudière gaz condensation avec contrôle combustion et ramonage"
    },
    {
      id: 8,
      name: "François Girard",
      location: "Plan-les-Ouates, Genève",
      service: "Installation Borne Recharge VE",
      rating: 5,
      date: "Septembre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20male%20electric%20car%20owner%20in%20his%20forties%20standing%20near%20modern%20garage%20with%20natural%20lighting%20and%20contemporary%20swiss%20architecture&width=400&height=400&seq=test8&orientation=squarish",
      text: "Installation d'une wallbox 22kW pour notre Tesla à Plan-les-Ouates. L'électricien a parfaitement dimensionné l'installation : câblage renforcé, protection différentielle adaptée, disjoncteur magnéto-thermique. Travail soigné et conforme aux normes. Nous rechargeons maintenant notre voiture électrique à domicile en toute sécurité. Excellent service !",
      project: "Wallbox 22kW triphasée avec câblage 10mm² et protection différentielle 30mA"
    },
    {
      id: 9,
      name: "Sylvie Roux",
      location: "Chêne-Bougeries, Genève",
      service: "Installation Panneaux Solaires",
      rating: 5,
      date: "Janvier 2025",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20female%20environmental%20advocate%20in%20her%20fifties%20in%20bright%20modern%20swiss%20home%20with%20natural%20lighting%20and%20eco%20friendly%20design&width=400&height=400&seq=test9&orientation=squarish",
      text: "Installation de 24 panneaux solaires photovoltaïques sur notre toiture à Chêne-Bougeries. Production de 8kWc avec onduleur et système de monitoring. HB SERVICES a géré toutes les démarches administratives et les demandes de subventions. Installation rapide, propre et professionnelle. Nous produisons maintenant notre propre électricité !",
      project: "Installation photovoltaïque 8kWc avec onduleur Fronius et monitoring en ligne"
    },
    {
      id: 10,
      name: "Daniel Favre",
      location: "Bernex, Genève",
      service: "Remplacement Chauffe-eau",
      rating: 5,
      date: "Décembre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20male%20homeowner%20in%20his%20fifties%20in%20modern%20swiss%20basement%20utility%20room%20with%20natural%20lighting%20and%20clean%20technical%20environment&width=400&height=400&seq=test10&orientation=squarish",
      text: "Remplacement de notre vieux boiler électrique par un chauffe-eau thermodynamique à Bernex. Excellent choix recommandé par HB SERVICES ! Économies d'énergie de 70% sur l'eau chaude sanitaire. Installation rapide et soignée. Le plombier a parfaitement raccordé le système et expliqué le fonctionnement. Très satisfait du résultat.",
      project: "Chauffe-eau thermodynamique 250L avec pompe à chaleur intégrée"
    },
    {
      id: 11,
      name: "Martine Dubois",
      location: "Petit-Lancy, Genève",
      service: "Désembouage Chauffage",
      rating: 5,
      date: "Novembre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20female%20homeowner%20in%20her%20sixties%20in%20warm%20comfortable%20swiss%20living%20room%20with%20natural%20lighting%20and%20cozy%20atmosphere&width=400&height=400&seq=test11&orientation=squarish",
      text: "Désembouage complet de notre installation de chauffage à Petit-Lancy. Nos radiateurs ne chauffaient plus correctement. L'équipe a effectué un nettoyage hydraulique complet avec produit détartrant et rinçage. Résultat impressionnant ! Les radiateurs chauffent maintenant uniformément et notre chaudière consomme moins. Service professionnel et efficace.",
      project: "Désembouage installation chauffage 12 radiateurs avec nettoyage hydraulique"
    },
    {
      id: 12,
      name: "Alain Mercier",
      location: "Confignon, Genève",
      service: "Installation Adoucisseur d'Eau",
      rating: 5,
      date: "Octobre 2024",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20male%20homeowner%20in%20his%20fifties%20in%20modern%20swiss%20kitchen%20with%20natural%20lighting%20and%20contemporary%20appliances&width=400&height=400&seq=test12&orientation=squarish",
      text: "Installation d'un adoucisseur d'eau à Confignon pour protéger nos installations du calcaire. L'eau de Genève est très dure et endommageait notre chaudière et notre robinetterie. Depuis l'installation, plus de problème de tartre ! Le plombier a parfaitement dimensionné l'adoucisseur et expliqué l'entretien. Investissement rentabilisé rapidement.",
      project: "Adoucisseur d'eau 25L avec vanne automatique et système de régénération"
    }
  ];

  const stats = [
    { number: "500+", label: "Clients Satisfaits" },
    { number: "4.9/5", label: "Note Moyenne" },
    { number: "98%", label: "Recommandations" },
    { number: "19+", label: "Ans d'Expérience" }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Témoignages Clients Neuenegg | Avis CasaReNovaPlus Suisse Romande"
        description="Découvrez les avis de nos clients satisfaits à Genève et en Suisse romande. Plus de 500 projets réalisés avec succès en chauffage, électricité, sanitaire et ventilation. Note 4.9/5."
        keywords="témoignages CasaReNovaPlus, avis clients Neuenegg, avis rénovation Fribourg, satisfaction clients Suisse romande"
        canonical={`${import.meta.env.VITE_SITE_URL}/temoignages`}
        schema={schema}
      />
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Témoignages Clients
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto mb-8">
            Découvrez les avis de nos clients satisfaits à Genève et environs. Plus de 100 projets réalisés avec succès en chauffage, électricité, sanitaire et ventilation.
          </p>
          <div className="flex items-center justify-center gap-2 text-white">
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-2xl"></i>
              ))}
            </div>
            <span className="text-2xl font-bold ml-2">4.9/5</span>
            <span className="text-lg ml-2">(500+ avis)</span>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">{stat.number}</div>
                <div className="text-gray-600 font-semibold">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition-all duration-300">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900 text-lg">{testimonial.name}</h3>
                    <p className="text-sm text-gray-600">{testimonial.location}</p>
                    <div className="flex gap-1 mt-1">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 bg-teal-100 text-teal-700 rounded-full text-xs font-semibold">
                    {testimonial.service}
                  </span>
                  <span className="ml-2 text-xs text-gray-500">{testimonial.date}</span>
                </div>

                <p className="text-gray-700 text-sm leading-relaxed mb-4">
                  {testimonial.text}
                </p>

                <div className="pt-4 border-t border-gray-200">
                  <p className="text-xs text-gray-600 italic">
                    <strong>Projet :</strong> {testimonial.project}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-teal-600 to-teal-800">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Rejoignez Nos Clients Satisfaits
          </h2>
          <p className="text-white/90 mb-8 text-lg">
            Confiez-nous votre projet de chauffage, électricité, sanitaire ou ventilation à Genève
          </p>
          <a 
            href="#contact"
            className="inline-block px-8 py-4 bg-white text-teal-600 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-lg"
          >
            Demander un Devis Gratuit
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
